<template>
  <div class="modal fade" ref="modalEle" tabindex="-1">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">Wybierz artykuły</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">

          <ejs-grid
              ref="grid"
              :dataSource="warehouseDataManager"
              :allowPaging="true"
              :allowSorting="true"
              :allowFiltering="true"
              :selectionSettings="selectionOptions">

<e-columns>
  <e-column
      field="id"
      :isPrimaryKey="true"
      :visible="false"
  />

  <e-column type="checkbox" width="60"/>

  <e-column field="article.catalog_number" headerText="Nr artykułu"/>
  <e-column field="article.model" headerText="Model"/>
  <e-column field="article.description" headerText="Opis"/>
  <e-column field="quantity" headerText="Stan"/>
  <e-column field="article_warehouse.short_name" headerText="Magazyn"/>
</e-columns>

          </ejs-grid>

        </div>

        <div class="modal-footer">
          <button
              class="btn btn-primary"
              @click="confirmSelection">
            Dodaj
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Sort,
  Filter
} from "@syncfusion/ej2-vue-grids";

import { DataManager, WebMethodAdaptor, Query } from "@syncfusion/ej2-data";
import { usePage } from "@inertiajs/vue3";

export default {

  components: {
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective
  },
props: {
  warehouseId: {
    type: [Number, String],
    default: null
  }
},
  provide: {
    grid: [Page, Sort, Filter]
  },

  data() {
    return {

      modalObj: null,

      selectionOptions: {
        type: 'Multiple',
        persistSelection: true
      },

warehouseDataManager: new DataManager({
  url: route('warehouse.getArticleList'),
  adaptor: new WebMethodAdaptor(),
  headers: [
    {
      'X-CSRF-TOKEN': usePage().props.csrf_token
    }
  ]
}),
    };
  },
watch: {
  warehouseId(newVal) {
    if (!newVal) return;

    const grid = this.$refs.grid?.ej2Instances;

    grid.query = new Query()
      .where('article_warehouse_id', 'equal', newVal)
      .where('quantity', 'greaterThan', 0);
  }
},
  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
  },

  methods: {

show() {
  const grid = this.$refs.grid?.ej2Instances;

  if (grid && this.warehouseId) {
    grid.query = new Query()
      .where('article_warehouse_id', 'equal', Qthis.warehouseId)
      .where('quantity', 'greaterThan', 0);
  }

  this.modalObj.show();
},

hide() {
  this.modalObj.hide();

  const grid = this.$refs.grid?.ej2Instances;
  if (grid) {
    grid.query = new Query();
  }
},

confirmSelection() {
  const selected = [
    ...this.$refs.grid.ej2Instances.getSelectedRecords()
  ];

  this.$emit('select-items', selected);

  this.hide();
}
  }
}
</script>